import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from 'app/core/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  user:any;
  // --------- Constructor ----------- //
  constructor(
    private _authService: AuthService,
    private router: Router,
  ) {
    this._authService.currentUser.subscribe({
      next: (res: any) => {
          if (res) {
              this.user = res;
              console.log('user', this.user);
          }
      },
  });
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Can activate
   *
   * @param route
   * @param state
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    console.log('canActivate');
    console.log('auth token', this._authService.accessToken);
    if(this._authService.accessToken) {
      return true
    } 
    this.router.navigate(['/auth/signin']);
    return false;
  }

  /**
  * Can activate child
  *
  * @param childRoute
  * @param state
  */

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    console.log('canActivateChild')
    if(this._authService.accessToken) {
      return true;
    } 
    this.router.navigate(['/auth/signin']);
    return false;

    
  }

  /**
    * Can Load Component
    *
    * @param childRoute
    * @param state
    */

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    // console.log('canLoad')
    if(this._authService.accessToken) {
      return true;
    }
    this.router.navigate(['/auth/signin']);
    return false;
  }
}
